import { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import Navbar from '../Components/Navbar'
import monika from '../Assets/monika banner.png'
import monikanew from '../Assets/monika new.png'



import about from '../Assets/ab1.png'
import icon from '../Assets/icons (1).png'
import serviceicon from '../Assets/serviceicon.png'
import serviceicon2 from '../Assets/sicon2.svg'
import serviceicon3 from '../Assets/sicon3.png'
import rj from '../Assets/rj.png'
import star from '../Assets/Background.png'
import dr from '../Assets/newimg2.png'
import nicon from '../Assets/abicon.png'
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import s2 from '../Assets/final1.jpg'
import s1 from '../Assets/news4.jpg'
import s3 from '../Assets/final4.png'

import img from "../Assets/service5.jpg";
import img2 from "../Assets/service7.jpg";
import img3 from "../Assets/service9.jpg";

import g1 from "../Assets/g1.jpeg";
import g2 from "../Assets/g2.jpeg";
import g3 from "../Assets/g3.jpeg";
import g4 from "../Assets/g4.jpeg";
import g5 from "../Assets/g5.jpeg";
import g6 from "../Assets/g6.jpeg";
import g7 from "../Assets/g7.jpeg";
import g8 from "../Assets/g8.jpeg";
import g9 from "../Assets/g9.jpeg";
import g10 from "../Assets/g10.jpeg";
import g11 from "../Assets/g11.jpeg";
import g12 from "../Assets/g12.jpeg";
import g13 from "../Assets/g13.jpeg";
import g14 from "../Assets/g14.jpeg";
import g15 from "../Assets/g15.jpeg";
import g16 from "../Assets/g16.jpeg";
import g17 from "../Assets/g17.jpeg";
import g18 from "../Assets/g18.jpeg";
import g19 from "../Assets/g19.jpeg";
// import g20 from "../Assets/g20.jpeg";
import g21 from "../Assets/g21.jpeg";
import g22 from "../Assets/g22.jpeg";
import g23 from "../Assets/g23.jpeg";
import g24 from "../Assets/g24.jpeg";
import g25 from "../Assets/g25.jpeg";
import g26 from "../Assets/g26.jpeg";
import g27 from "../Assets/g27.jpeg";
import g28 from "../Assets/g28.jpeg"; 
import { Helmet } from "react-helmet";
import {
  Award,
  Microscope,
  HeartPulse,
  UserRoundCheck
} from "lucide-react";


const images = [
  g1,g2,g3,g4,g5,g6,g7,g8,g9,g10,
  g11,g12,g13,g14,g15,g16,g17,g18,
  g19,g21,g22,g23,g24,g25,g26,g27,g28
];


const blogs = [
    {
      image: img,
      title: "Understanding PCOS & Its Impact on Fertility",
      desc: "Learn how PCOS affects women’s health and what steps you can take to manage it effectively."
    },
    {
      image: img2,
      title: "Healthy Pregnancy Tips Every Woman Should Know",
      desc: "Simple lifestyle and diet tips to ensure a smooth and healthy pregnancy journey."
    },
    {
      image: img3,
      title: "When Should You Consult a Fertility Specialist?",
      desc: "Know the right time to seek expert help and improve your chances of conception."
    }
  ];


const hospitalSchedule = {
  "Aadhya 9 Hospital, Shadipur": {
    days: ["Monday","Wednesday","Thursday","Saturday","Sunday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Apollo Cradle, Moti Nagar": {
    days: ["Tuesday","Friday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Kailash IVF, Noida": {
    days: ["Monday","Tuesday","Wednesday","Friday","Saturday","Sunday"],
    time: "9:00 AM - 1:00 PM"
  }
};


function Home() {
const hospitalSchedule = {
  "Aadhya 9 Hospital, Shadipur": {
    days: ["Monday","Wednesday","Thursday","Saturday","Sunday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Apollo Cradle, Moti Nagar": {
    days: ["Tuesday","Friday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Kailash IVF, Noida": {
    days: ["Monday","Tuesday","Wednesday","Friday","Saturday","Sunday"],
    time: "9:00 AM - 1:00 PM"
  }
};

const [hospital,setHospital] = useState("");
const [date,setDate] = useState("");
const [time,setTime] = useState("");

const [name,setName] = useState("");
const [phone,setPhone] = useState("");
const [email,setEmail] = useState("");
const firstRow = images.slice(0, Math.ceil(images.length / 2)); const secondRow = images.slice(Math.ceil(images.length / 2));

const handleDate = (value) => {

  if(!hospital){
    alert("Please select hospital first");
    return;
  }

  const selectedDate = new Date(value);
  const day = selectedDate.toLocaleString("en-US",{weekday:"long"});

  if(hospitalSchedule[hospital]?.days.includes(day)){
    setDate(value);
    setTime(hospitalSchedule[hospital].time);
  }
  else{
    alert("Doctor not available on this day");
    setDate("");
    setTime("");
  }
}


const sendWhatsapp = async () => {

  if(!name || !phone || !email || !hospital || !date){
    alert("Please fill all required fields including email");
    return;
  }

  const templateParams = {
    name,
    phone,
    email,
    hospital,
    date,
    time
  };

  const message = `Appointment Booking

Name: ${name}
Phone: ${phone}
Hospital: ${hospital}
Date: ${date}
Time: ${time}
Email: ${email}
`;

  const whatsappUrl = `https://wa.me/917703895964?text=${encodeURIComponent(message)}`;

  try {

    await emailjs.send(
      "service_n802jco",
      "template_g6paq09",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("Admin mail sent");

    await emailjs.send(
      "service_n802jco",
      "template_2i7nheg",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("User mail sent");

    alert("Appointment booked successfully!");

    // IMPORTANT CHANGE
    window.location.href = whatsappUrl;

    setName("");
    setPhone("");
    setEmail("");
    setHospital("");
    setDate("");
    setTime("");

  } catch (err) {
    console.log("ERROR:", err);
    alert("Something went wrong! Check console.");
  }

};

  // const handleDate = (value) => {

  //   const selectedDate = new Date(value);
  //   const day = selectedDate.toLocaleString("en-US",{weekday:"long"});

  //   if(hospitalSchedule[hospital]?.days.includes(day)){
  //     setDate(value);
  //     setTime(hospitalSchedule[hospital].time);
  //   }
  //   else{
  //     alert("Doctor not available on this day");
  //     setDate("");
  //     setTime("");
  //   }

  // }

const testimonials = [
  {
    id: 1,
    image: rj,
    text: "After years of trying, we finally found hope at Kailash IVF. Dr. Monika Gupta’s guidance and positivity made our journey smooth and successful.",
    name: "Simran & Manjit",
  },
  {
    id: 2,
    image: rj,
    text: "Dr. Gupta explained every step clearly and treated us with genuine care. We always felt supported and confident throughout the IVF process.",
    name: "Neha & Rohan",
  },
  {
    id: 3,
    image: rj,
    text: "Professional, ethical, and compassionate — the entire team at Kailash IVF stood by us. Today, we are blessed with happiness beyond words.",
    name: "Pooja & Amit",
  },
  {
    id: 4,
    image: rj,
    text: "From consultation to treatment, everything was handled with expertise and warmth. We are truly grateful to Dr. Monika Gupta for making our dream come true.",
    name: "Anjali & Karan",
  },
];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    if (current < testimonials.length - 3) {
      setCurrent(current + 1);
    }
  };

  const prevSlide = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoad(true);
    }, 800); // thoda delay zaroori hai

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    <Helmet>
  <title>Best IVF Specialist in Delhi | Dr. Monika Gupta | Fertility Expert</title>

  <meta
    name="description"
    content="Consult Dr. Monika Gupta, leading IVF & fertility specialist in Delhi with 15+ years experience. Expert in IVF, IUI, ICSI, PCOS & infertility treatment."
  />

  <meta
    name="keywords"
    content="IVF specialist Delhi, best IVF doctor Delhi, fertility clinic Delhi, IVF treatment Delhi, infertility specialist Delhi, IUI treatment Delhi, ICSI treatment Delhi, PCOS treatment Delhi, IVF Patel Nagar"
  />

  <meta property="og:title" content="Best IVF Specialist in Delhi | Dr. Monika Gupta" />
  <meta property="og:description" content="Expert IVF & fertility treatments with high success rate in Delhi." />
  <meta property="og:type" content="website" />
</Helmet>
        <Navbar/>
        <div className='home-banner'>
<div className='home-banner-left'>
<div>
  <p><img src={star}/> 5-Star Rating </p>
</div>
<h3>Dr. Monika Gupta</h3>
<h6>Senior Fertility Specialist, Obstetrician & Gynaecologist</h6>
{/* <h5>IVF Specialist at Aadhya 9 Hospital, Shadipur</h5> */}
<h5>15+ Years of Experience in Reproductive Medicine & Women’s Health.

Advanced & Ethical Fertility and Women’s Care to Support You at Every Stage — From Conception to Safe Delivery.</h5>
<a href="#booking">
  <button>Request Appointment</button>
</a>
        </div>
        <div className='home-banner-right'>
<img src={monika}/>
        </div>
        </div>
        <div className='about-div1'>
    <div className='about-div-left1'>
<img src={about}/>
        </div>
    <div className='about-div-right1'>
  <h3>About Dr. Monika Gupta</h3>
  
  <p>
    Dr. Monika Gupta is a highly experienced IVF & Fertility Specialist, Obstetrician and Gynaecologist with over 15 years of clinical expertise in reproductive medicine and women’s healthcare.
    
    <br/><br/>

    I am currently practicing as a Fertility Specialist, Obstetrician and Gynaecologist at:
    <br/>Aadhya 9 Hospital, Shadipur
    <br/>Apollo Cradle, Moti Nagar 
    <br/>Kailash Hospital, Noida
    
    <br/><br/>

    Previous professional experience includes:
    <br/><br/>

    Indira IVF, Patel Nagar – 6 Years
    <br/>
    Akanksha IVF – 3 Years

    <br/><br/>

    <strong>Areas of Interest:</strong>
    <br/>• Infertility  
    <br/>• High-Risk Obstetrics  
    <br/>• Gynae Endoscopy (Laparoscopy & Hysteroscopy)  
    <br/>• Cosmetic Gynaecological Surgeries  

    <br/><br/>

    <strong>Meet Your Expert</strong>
    <br/>
    
 I specialize in advanced fertility treatments, high-risk pregnancy management, and minimally invasive gynecological procedures. With a patient-centric and transparent approach, I combine modern reproductive technology with dedicated care to ensure trusted and effective treatment outcomes for couples and women seeking fertility and maternity solutions.
  
  </p>

  <Link to='/about'>
    <button>Learn more about me</button>
  </Link>
</div>
        </div>
        {/* <div className='happyclient-div'>
    <div className='happyclient'>
     <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>

        </div>
        </div> */}
    <div className='qualityservices'>
    <h2>Quality Care Services</h2>

    {/* <div className='qualityservices-div'>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Ovulation Induction</h3>
            <p>Customized treatment plans to stimulate healthy egg development and improve natural conception chances.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon2}/>
            <h3>Intrauterine Insemination (IUI)</h3>
            <p>A minimally invasive procedure that enhances fertilization by placing prepared sperm directly into the uterus.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon3}/>
            <h3>In-Vitro Fertilization (IVF)</h3>
            <p>Advanced assisted reproductive technology where fertilization is performed outside the body to increase pregnancy success rates.</p>
        </div> */}

        {/* <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Transvaginal Oocyte Retrieval</h3>
            <p>A precise and safe procedure to collect mature eggs as part of the IVF process.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Embryo Transfer</h3>
            <p>Carefully selected healthy embryos are transferred into the uterus to maximize implantation and pregnancy outcomes.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Laparoscopy & Hysteroscopy</h3>
            <p>Minimally invasive diagnostic and surgical procedures for treating infertility-related gynecological conditions.</p>
        </div>

       

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Egg Freezing</h3>
            <p>Oocyte cryopreservation to preserve fertility for future family planning due to medical or personal reasons.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Laser Assisted Hatching</h3>
            <p>An advanced IVF technique that improves embryo implantation by gently thinning the outer shell of the embryo.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Blastocyst Culture</h3>
            <p>Extended embryo culture to the blastocyst stage to enhance implantation rates and improve IVF success.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>TESA / TESE / PESA</h3>
            <p>Advanced surgical sperm retrieval techniques used in male infertility cases for IVF/ICSI treatment.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Normal Vaginal Delivery</h3>
            <p>Comprehensive prenatal care and safe management of natural childbirth for healthy mother and baby.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>Cesarean Section (C-Section)</h3>
            <p>Safe and planned surgical delivery for high-risk or medically indicated pregnancies.</p>
        </div>

        <div className='qualityservices-boxs'>
            <img src={serviceicon}/>
            <h3>High-Risk Pregnancy Care</h3>
            <p>Specialized monitoring and expert management of complicated pregnancies to ensure safe outcomes.</p>
        </div> */}

    {/* </div> */}


<section className="services services2">
  <div className="services-grid">

    <div className="card">
      <div className="card-img">
        <img src={s1} alt="Ovulation Induction" />
      </div>
      <h3>Ovulation Induction</h3>
      <p>
        Customized treatment plans to stimulate healthy egg development and 
        improve natural conception chances.
      </p>
      <a href="/contact" className="link">
        Schedule a check-up <span>→</span>
      </a>
    </div>

    <div className="card">
      <div className="card-img">
        <img src={s2} alt="Intrauterine Insemination (IUI)" />
      </div>
      <h3>Intrauterine Insemination (IUI)</h3>
      <p>
        A minimally invasive procedure that enhances fertilization by placing 
        prepared sperm directly into the uterus.
      </p>
      <a href="/contact" className="link">
        Schedule a check-up <span>→</span>
      </a>
    </div>

    <div className="card">
      <div className="card-img">
        <img src={s3} alt="In-Vitro Fertilization (IVF)" />
      </div>
      <h3>In-Vitro Fertilization (IVF)</h3>
      <p>
        Advanced assisted reproductive technology where fertilization is 
        performed outside the body to increase pregnancy success rates.
      </p>
      <a href="/contact" className="link">
        Schedule a check-up <span>→</span>
      </a>
    </div>

  </div>
</section>

    
<Link to='/services'>
    <button>View All Services</button>
</Link>
</div>


      <section className="why-section">
  <h2 className="why-title">Why Choose Dr. Monika Gupta?</h2>

  <div className="why-container">
    
    {/* LEFT SIDE */}
<div className="why-cards">

  <div className="why-card">
    <div className="icon">
      <Award size={32} strokeWidth={1.8} />
    </div>
    <h3>15+ Years of Experience</h3>
    <p>
      Extensive expertise in IVF, infertility treatment, obstetrics and gynecology care.
    </p>
  </div>

  <div className="why-card">
    <div className="icon">
      <Microscope size={32} strokeWidth={1.8} />
    </div>
    <h3>Advanced IVF Techniques</h3>
    <p>
      Skilled in IVF, IUI, Egg Freezing, Blastocyst Culture and modern reproductive procedures.
    </p>
  </div>

  <div className="why-card">
    <div className="icon">
      <HeartPulse size={32} strokeWidth={1.8} />
    </div>
    <h3>Complete Women’s Care</h3>
    <p>
      From fertility treatment to normal and cesarean delivery under expert supervision.
    </p>
  </div>

  <div className="why-card">
    <div className="icon">
      <UserRoundCheck size={32} strokeWidth={1.8} />
    </div>
    <h3>Ethical & Patient-Centric Approach</h3>
    <p>
      Transparent guidance, personalized plans and dedicated support at every step.
    </p>
  </div>

</div>

    {/* RIGHT SIDE */}
    <div className="why-image">
      <img src={dr} alt="Doctor" />
    </div>

  </div>
</section>


 <section className="mvx-section">
      <div className="mvx-container">

        {/* Heading */}
        <div className="mvx-header">
          <span className="mvx-subtitle">Our Purpose</span>
          <h2 className="mvx-title">Mission & Vision</h2>
        </div>

        {/* Cards */}
        <div className="mvx-grid">

          {/* Mission */}
          <div className="mvx-card mvx-mission">
           <i class="bi bi-bullseye"></i>
            <h3>Our Mission</h3>
            <p>
       To provide ethical and advanced fertility and women’s healthcare solutions, ensuring every patient receives personalized treatment and support throughout their journey to parenthood.
            </p>
          </div>

          {/* Vision */}
          <div className="mvx-card mvx-vision">
           <i class="bi bi-eye-fill"></i>
            <h3>Our Vision</h3>
            <p>
              To become a trusted name in fertility and women’s healthcare by delivering
              world-class treatment, innovation, and care that empowers families to grow
              with confidence and happiness.
            </p>
          </div>

        </div>
      </div>
    </section>

<>
    <section className="fs-section">
      <div className="fs-container">

        {/* LEFT IMAGE */}
        <div className="fs-image">
          <img src={monikanew} alt="Dr Monika Gupta" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="fs-content">
          <span className="fs-subtitle">Words from Our Founder</span>
          
          <h2 className="fs-title">
            A Message from <br /> Dr. Monika Gupta
          </h2>

          <p className="fs-text">
         “Every patient’s journey is unique, and my goal is to provide not just treatment but emotional support, trust, and hope. With advanced fertility solutions and dedicated care, we strive to turn dreams of parenthood into reality.”
          </p>

          <div className="fs-signature">
            <h4>Dr. Monika Gupta</h4>
            <span>Fertility Specialist & Gynaecologist</span>
          </div>
        </div>

      </div>
    </section>

</>

 <section className="cs-section">
      <div className="cs-container">

        {/* LEFT */}
        <div className="cs-left">
          <h2>
            Get in touch with our <br /> expert today!
          </h2>
        </div>

        {/* RIGHT */}
        <div className="cs-right">

          {/* CALL */}
          <div className="cs-box">
            <div className="cs-icon">
              <i className="bi bi-telephone-fill"></i>
            </div>
            <div>
              <p className="cs-label">Call Us</p>
              <a href="tel:+917703895964" className="cs-text">
                +91 7703895964
              </a>
            </div>
          </div>

          {/* EMAIL */}
          <div className="cs-box">
            <div className="cs-icon">
              <i className="bi bi-envelope-fill"></i>
            </div>
            <div>
              <p className="cs-label">Email Us</p>
              <a href="mailto:drmonicaivf@gmail.com" className="cs-text">
                drmonicaivf@gmail.com
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>





 {/* <section className="testimonial-section">
      <h2 className="testimonial-title">Patient Testimonials</h2>

      <div className="testimonial-wrapper">
        <div
          className="testimonial-slider"
          style={{ transform: `translateX(-${current * 340}px)` }}
        >
          {testimonials.map((item) => (
            <div className="testimonial-card" key={item.id}>
              <img src={item.image} alt="patient" />
              <div className="testimonial-content">
                <div className="quote">“</div>
                <p>{item.text}</p>
                <h4>{item.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="testimonial-controls">
        <button onClick={prevSlide} className="arrow">‹</button>

        <div className="dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={index === current ? "dot active" : "dot"}
            ></span>
          ))}
        </div>

        <button onClick={nextSlide} className="arrow">›</button>
      </div>
    </section> */}
            {/* <section className="blog-section">
      <h2 className="blog-title">Blog & Insights</h2>

      <div className="blog-container blog-container-1">
        {blogs.map((blog) => (
          <div className="blog-card" key={blog.id}>
            <img src={blog.image} alt="blog" />
            <h3>{blog.title}</h3>
            <a href="#" className="read-more">
              Read more →
            </a>
          </div>
        ))}
      </div>

      <div className="blog-btn-wrapper">
        <button className="view-btn">View all blogs</button>
      </div>
    </section> */}
<div className="client-timing" id="booking">
  <div className="client-timing-left" >
<div className="client-timing-left-form">

<h4>Make an appointment</h4>

<div className="ips">
<div className="ip">
<label>Full Name</label>
<input type="text" value={name} onChange={(e)=>setName(e.target.value)}/>
</div>

<div className="ip">
<label>Phone</label>
<input type="text" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
</div>
</div>

<div className="ips">
<div className="ip">
<label>Select Hospital</label>

<select
value={hospital}
onChange={(e)=>setHospital(e.target.value)}
>
<option value="">Select Hospital</option>
<option>Aadhya 9 Hospital, Shadipur</option>
<option>Apollo Cradle, Moti Nagar</option>
<option>Kailash IVF, Noida</option>
</select>

</div>

<div className="ip">
<label>Select Date</label>

<input
type="date"
min={new Date().toISOString().split("T")[0]}
value={date}
onChange={(e)=>handleDate(e.target.value)}
/>

</div>
</div>

<div className="ips">

<div className="ip">
<label>Available Time</label>

<input
type="text"
value={time}
readOnly
/>
</div>

<div className="ip">
<label>Email</label>
<input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
</div>

</div>

<button onClick={sendWhatsapp}>
Book an appointment
</button>

</div>
    </div>
</div>
 <div style={{ minHeight: "300px" }}>
      {load && (
        <div className="elfsight-app-03a1fa93-60f4-4ebb-8dc4-50e91a6db56b"></div>
      )}
    </div>
 
   <br/>



  <div className="marquee-section">

       <div className="mvx-header">
  <span className="mvx-subtitle">Our Success</span>
  <h2 className="mvx-title">90% Success Rate With 5000+ Happy Couples</h2>
</div>

      {/* Row 1 */}
      <div className="marquee-container">
        <div className="marquee-track">
          {[...firstRow, ...firstRow].map((img, i) => (
            <img key={i} src={img} alt="img" className="marquee-img" />
          ))}
        </div>
      </div>

      {/* Row 2 */}
      <div className="marquee-container">
        <div className="marquee-track reverse">
          {[...secondRow, ...secondRow].map((img, i) => (
            <img key={i} src={img} alt="img" className="marquee-img" />
          ))}
        </div>
      </div>
  <div className="marquee-container">
        <div className="marquee-track">
          {[...firstRow, ...firstRow].map((img, i) => (
            <img key={i} src={img} alt="img" className="marquee-img" />
          ))}
        </div>
      </div>
    </div>




<section className="blg-section">
      <div className="blg-container">

        {/* Heading */}
        <div className="blg-header">
          <span>Our Blog</span>
          <h2>Women’s Health & Fertility Insights</h2>
        </div>

        {/* Cards */}
        <div className="blg-grid">
          {blogs.map((item, index) => (
            <div className="blg-card" key={index}>
              
              <div className="blg-img">
                <img src={item.image} alt="blog" />
              </div>

              <div className="blg-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <a href="#" className="blg-link">
                  Read More →
                </a>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>

    <Footer/>
    </>
  )
}

export default Home